import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo.png";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const HeaderDashboard = ({ clname = "", handleMobile }) => {
    console.log(clname, "it is in header2")
    const [activeIndex, setActiveIndex] = useState(null);
    const [logoSize, setLogoSize] = useState('75%');
    const handleDropdown = (index) => {
        setActiveIndex(index);
    };

    const UserId = sessionStorage.getItem("userId");
    const token = sessionStorage.getItem("token");
    const [scroll, setScroll] = useState(0);

    useEffect(() => {
        document.addEventListener("scroll", () => {
            const scrollCheck = window.scrollY > 100;
            if (scrollCheck !== scroll) {
                setScroll(scrollCheck);
            }
        });
    }, []);

    const navigate = useNavigate();

    const handleLogout = () => {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userId");
        toast.success("Logout  successfully", { autoClose: 2000 });
        setTimeout(() => {
            navigate("/login");
        }, 1000);
    };
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 1200) {
                setLogoSize('75%');
            } else if (window.innerWidth > 768) {
                setLogoSize('50%');
            } else {
                setLogoSize('30%');
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Set initial size

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (
        <header
            id="header"
            className={`header header-default ${scroll ? "is-fixed is-small" : ""}`}
        >
            <div className="tf-container ct2">
                <div className="row">
                    <div className="col-md-12">
                        <div className="sticky-area-wrap">
                            <div className="header-ct-left">
                                <div id="logo" className="logo">
                                    <Link to="/candidateDashboard">
                                        <img
                                            className="site-logo"
                                            id="trans-logo"
                                            src={logo}
                                            alt="Image"
                                            style={{
                                                maxWidth: logoSize,
                                                height: "auto",
                                            }}
                                        />
                                    </Link>

                                </div>
                            </div>
                            <div className="header-ct-center">
                                <div className="nav-wrap">
                                    <nav id="main-nav" className="main-nav">
                                        <ul id="menu-primary-menu" className={`menu ${clname}`}>
                                            <li className=" sub1">
                                                <Link to="/candidateDashboard">Dashboard</Link>
                                            </li>
                                            <li className=" menu-item sub2">
                                                <Link to="/all-jobs">All Jobs</Link>
                                            </li>
             
                                        </ul>
                                    </nav>
                                </div>
                            </div>

                            <div className="header-ct-right">
                    
                                <div className="header-customize-item account">
                            
                                </div>
                                <div
                                    style={{ width: "200px", overflowX: "auto" }}
                                    className="button"
                                >
                                    {console.log(UserId, "userId175")}
                                    {UserId && token ? (
                                        <Link onClick={handleLogout}>Log out</Link>
                                    ) : (
                                        <Link to="/login">Log in</Link>
                                    )}
                                </div>
                            </div>
                            <div className="nav-filter" onClick={handleMobile}>
                                <div className="nav-mobile">
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>

    )
}

export default HeaderDashboard